"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_c("b-field", [_c("b-autocomplete", {
    attrs: {
      data: _vm.data,
      placeholder: "Pesquisar items...",
      field: "title",
      "keep-first": _vm.keepFirst,
      "open-on-focus": _vm.openOnFocus,
      clearable: _vm.clearable,
      loading: _vm.isFetching,
      "check-infinite-scroll": ""
    },
    on: {
      typing: _vm.getAsyncData,
      "infinite-scroll": _vm.getMoreAsyncData,
      select: _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("div", {
          staticClass: "autocomplete-item"
        }, [_c("div", {
          staticClass: "autocomplete-item__title"
        }, [_vm._v("\n            " + _vm._s(props.option.title) + "\n          ")]), _vm._v(" "), props.option.description ? _c("div", {
          staticClass: "autocomplete-item__description"
        }, [_vm._v("\n            " + _vm._s(props.option.description) + "\n          ")]) : _vm._e()])];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_vm.isFetching ? _c("span", {
          staticClass: "has-text-grey"
        }, [_vm._v(" Carregando... ")]) : !_vm.data.length ? _c("span", {
          staticClass: "has-text-grey"
        }, [_vm._v(" Nenhum item encontrado... ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;